import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Input,
  Spinner,
  ModalFooter,
  Button,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import usePersistStoreData from "../Hooks/usePersistStoreData";
import { useFormik, Formik, Field, ErrorMessage, Form } from "formik";
import { useSelector } from "react-redux";
import NomineeFormFields from "../../pages/Profile/EditProfile/NomineeFormFields.js";

const EditNomineeDetailsModal = ({
  editModal,
  closeEditModal,
  editNomineeData,
  editIndex,
  nomineeList,
  setNomineeList,
  validationAddNominee,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;

  return (
    <Modal 
    isOpen={editModal} 
    centered={true} 
    className="contact_modal_custom"
    size="lg"
    >
      <ModalHeader
        toggle={closeEditModal}
        style={{
          backgroundColor: "#0F528D",
          paddingTop: "0.75rem",
          paddingBottom: "0.75rem",
        }}
      >
        <span className="fs-16 contact_note_header ">Edit Nominee Details</span>
      </ModalHeader>
      <ModalBody className="">
        <Formik
          enableReinitialize
          initialValues={editNomineeData}
          validationSchema={validationAddNominee}
          onSubmit={async (values, { setFieldTouched, validateForm }) => {
            // Touch conditional fields if minor
            if (values.is_minor === "1") {
              setFieldTouched("nominee_dob", true);
              setFieldTouched("nominee_gaurdian", true);
            }
            
            const errors = await validateForm();
            if (Object.keys(errors).length === 0) {
              // Your existing update logic
              const updated = [...nomineeList];
              updated[editIndex] = values;
              setNomineeList(updated);
              closeEditModal();
            }
          }}
        >
          {(formik) => (
            <Form onSubmit={formik.handleSubmit}>
              <ModalBody className="pt-0 pb-0">
                <NomineeFormFields
                  formik={formik}
                  colOverrides={{
                    nominee_identity: 6,
                    nominee_identity_class: "",
                  }}
                  isInModal={true}
                />
              </ModalBody>
              <div className="centerContent">
                <Button
                  className="fs-16"
                  color="primary"
                  type="submit"
                  style={{
                    minWidth: "120px",
                  }}
                >
                  Save
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default EditNomineeDetailsModal;
